import {connect} from 'react-redux'
import {currentSubjectSelector, createSubjectWithTrashedSelector, subjectsSelector} from '../../../../modules/subjects'
import {createCategorySelector, categoriesTreeMapSelector, createCategoryWithTrashedSelector} from '../../../../modules/categories'
import {showModal, hideModal} from '../../../../modules/modals'
import {createSourceSelector, currentSubjectSourcesSelector, createSourceWithTrashedSelector} from '../../../../modules/sources'
import {createQuestionSelector, setAnswerCorrectness, handleAnswerOk, handleAnswerCancel, changeDifficulty, /*checkAndChangeAnswer as TODO temp */ changeAnswer, formValidation, createAnswersSelector, incrAnswersCount, changeQuestionBody, changeQuestionDescription, handleQuestionSave, handleResetQuestionFormState, setQuestionFormState, toggleQuestionState, deleteQuestion, changeQuestionsStatuses, handleQuestionDelete, changeQuestionSource, changeQuestionCategory, createQuestionWithTrashedSelector, createCopyForm} from '../../../../modules/questions'
import QuestionForm from './QuestionForm'
import {createNewForm} from "../../../../modules/questions"
import { setLoadCursore } from '../../../../redux/actions'
import { getAnswersForSave, removePrefixCatSubcatId } from '../../../../modules/_utils'
import { isTeacherOrganisationSelector } from '../../../../modules/profile'

export default connect(
    () => {
        const subjectWithTrashedSelector = createSubjectWithTrashedSelector()
        const questionSelector = createQuestionSelector()
        const questionWithTrashedSelector = createQuestionWithTrashedSelector()
        const categorySelector = createCategorySelector()
        const categoryWithTrashedSelector = createCategoryWithTrashedSelector()
        const sourceSelector = createSourceSelector()
        const sourceWithTrashedSelector = createSourceWithTrashedSelector()
        const answersSelector = createAnswersSelector()

        return (state, ownProps) => {
            const {questionId, withTrashed = false} = ownProps;
            // console.log("questionId", questionId, withTrashed)
            const question = withTrashed ? questionWithTrashedSelector(state, questionId) : questionSelector(state, questionId)
            // console.log("🚀 ~ file: index.js ~ line 28 ~ return ~ question", question)
            const answers = answersSelector(state, questionId)
            const {source_id, category_id, subject_id} = question
            // console.log("question", question)
            const _category = withTrashed ? categoryWithTrashedSelector(state, category_id) : categorySelector(state, category_id)
            // console.log("_category", _category) 
            let category
            let subcategory
            if (_category && _category.parent_id) {
                category = withTrashed ? categoryWithTrashedSelector(state, _category.parent_id) : categorySelector(state, _category.parent_id)
                subcategory = _category
            } else {
                category = _category
            }

            let sources = currentSubjectSourcesSelector(state);

            
            // console.log("subject_id", subject_id)

            const currentSubject = withTrashed ? subjectWithTrashedSelector(state, subject_id) : currentSubjectSelector(state)
            // console.log("currentSubject", currentSubject)
            
            let categoriesTree = []
            if (currentSubject) {
                let categoriesIds = currentSubject.categoriesIds.keySeq().toArray()
                categoriesTree = Object.values(categoriesTreeMapSelector(state, categoriesIds))
            }

            const source = source_id ?
                            withTrashed ?
                                sourceWithTrashedSelector(state, source_id) :
                                sourceSelector(state, source_id) :
                            null;

            const getData = () => {
                const {body, description, difficulty, token, answerT1, answ_state, expl_state, category_id : _category_id, source_id, isNewForm, status = QUESTION_STATUSES[2].status, isCopyed,
                    subcategory_id: _subcategory_id, realCategory, subject_id: subj_id} = question
                    const {correct_answer} = answerT1
                    // const {id : subjectId} = currentSubjectSelector(state)
                    let category_id
                    let subcategory_id
                    if(!isCopyed && null === realCategory){
                        // console.log("getData -> _category_id", _category_id)
                        let category = categorySelector(state, _category_id)
                        // console.log("getData -> category", category)
                        if(category){
                            const {parent_id} = category
                            if (parent_id) {
                                category_id = parent_id
                                subcategory_id = _category_id
                            } else {
                                category_id = _category_id
                                subcategory_id = ""
                            }
                        }
                        
                    }
                    else{
                        if(null!==_subcategory_id){
                            category_id = realCategory
                            subcategory_id = _subcategory_id
                        }else{
                            category_id = realCategory
                            subcategory_id = ""
                        }
                    }
                    let answersForSave = getAnswersForSave(answerT1)
        
            
                    let _idDataQuestion = isNewForm ? {} : {id : questionId}
                    let _idDataAnswer = isNewForm ? {} : {question_id : questionId}
            
                    return {
                        ..._idDataQuestion,
                        category_id : category_id ? removePrefixCatSubcatId(category_id) : category_id,
                        subcategory_id : (subcategory_id ? removePrefixCatSubcatId(subcategory_id) : subcategory_id),
                        source_id,
                        question : body,
                        description : description,
                        answ_state,
                        answ_state,
                        difficulty,
                        token,
                        expl_state,
                        status,
                        subject_id: subj_id,
                        answerT1 : {
                            ..._idDataAnswer,
                            correct_answer,
                            ...answersForSave,
                        },
                    }
            }
            

            return {
                question,
                category : category || {},
                answers,
                categoriesTree,
                subcategory,
                sources,
                permission: state.profile.permission || {},
                isTeacherOrganisation: isTeacherOrganisationSelector(state),
                subject : currentSubjectSelector(state) || {},
                subjects : subjectsSelector(state) || {},
                source,
                initData: getData()
            }
        }
    },
    {createNewForm, setLoadCursore, setAnswerCorrectness, changeDifficulty, changeAnswer, formValidation, incrAnswersCount, handleAnswerOk, handleAnswerCancel, changeQuestionBody, changeQuestionDescription, handleQuestionSave, handleResetQuestionFormState, setQuestionFormState, toggleQuestionState, showModal, hideModal, deleteQuestion, changeQuestionsStatuses, handleQuestionDelete, changeQuestionSource, changeQuestionCategory, createCopyForm}
)(QuestionForm)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmBody/QuestionForm/index.js